import React from 'react'

const ProductDetail = () => {
  return (
    <div>Карточка товара</div>
  )
}

export default ProductDetail